import React from 'react';
import MaterialTable from 'material-table';

export default function CustomSimpleTable(props) {
  const [state, setState] = React.useState({
    columns: [
      { title: 'Self ID', field: 'id' },
      { title: 'Name', field: 'name' },
      { title: 'Upline', field: 'upline' },
      { title: 'Email', field: 'email' },
      { title: 'Mobile No', field: 'mobileNumber', type: 'numeric' },
     
    ],
    data: [
      { name: 'Mehmet', surname: 'Baran', birthYear: 1987, birthCity: 63 },
      {
        name: 'Zerya Betül',
        surname: 'Baran',
        birthYear: 2017,
        birthCity: 34,
      },
    ],
  });
  console.log(props)
  return (
    <MaterialTable
      title={props.title}
      columns={props.columns}
      data={props.data}
     
    />
  );
}
